module.exports = __webpack_public_path__ + "static/media/dr2-1.d3640549.jpg";